module.exports = __webpack_public_path__ + "static/og-8629c67e6a6295406b621107f5f5bd71.png";